import { createFileRoute } from '@tanstack/react-router';
import { PRIVACY_POLICY } from '@/features/creators/legal/content/privacy-policy';
import { LegalPage } from '@/features/creators/legal/legal-page';
import { seo } from '@/utils/seo';

// /ixi-finance/creators/privacy — ixigo Creators Privacy Policy. A standalone page
// (the trailing _ keeps it out of the landing route's layout).
export const Route = createFileRoute('/ixi-finance/creators_/privacy')({
	head: () => ({
		meta: [
			...seo({
				title: 'ixigo Creators — Privacy Policy',
				description:
					'How ixigo handles personal data, including for the ixigo Creators Program.',
			}),
			{ name: 'robots', content: 'index, follow' },
		],
	}),
	component: () => <LegalPage document={PRIVACY_POLICY} />,
	ssr: true,
});
